import axios from 'axios';

import c from '../helpers/constants';
import { getApiKey } from '../helpers/functions';

export function getColourGroups(customerid: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.COLOUR_GROUPS}?customerid=${encodeURIComponent(customerid)}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',       
        'x-api-key': getApiKey() 
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}